module.exports = function() {
  return new Worker(__webpack_public_path__ + "ad712f20de7276eff3fa.worker.js");
};